var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31359 1.13576L0.118419 8.02782C-0.207537 8.56332 0.17793 9.24921 0.804834 9.24921H9.19517C9.82207 9.24921 10.2075 8.56332 9.88158 8.02782L5.68641 1.13576C5.37333 0.621414 4.62667 0.621413 4.31359 1.13576Z",
    fill: "#C22121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.57031C5.26521 6.57031 5.46875 6.77384 5.46875 7.03906C5.46875 7.30427 5.26521 7.5078 5 7.5078C4.73479 7.5078 4.53125 7.30427 4.53125 7.03906C4.53125 6.77384 4.73479 6.57031 5 6.57031ZM5 3.25C5.25905 3.25 5.43791 3.35485 5.43174 3.62623L5.33306 5.81784C5.32689 6.07072 5.16653 6.15707 5 6.15707C4.83347 6.15707 4.67311 6.07072 4.66694 5.81784L4.56826 3.62623C4.56209 3.35485 4.74095 3.25 5 3.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.2446d2346fac55f91651e37c1c10e566.svg";
export { ForwardRef as ReactComponent };